import { Component, HostListener } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-upload-dialog',
    imports: [
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatIconModule,
        ReactiveFormsModule
    ],
    templateUrl: './upload-dialog.component.html',
    styleUrl: './upload-dialog.component.scss'
})
export class UploadDialogComponent {
  uploadForm: FormGroup;
  fileName: string | null = null;
  isDragOver = false;

  constructor(
    private dialogRef: MatDialogRef<UploadDialogComponent>,
    private fb: FormBuilder
  ) {
    this.uploadForm = this.fb.group({
      materialName: [''],
      file: [null, Validators.required]
    });
  }

  onFileSelected(event: any) {
    const file = event.target.files[0];
    this.processFile(file);
  }

  @HostListener('drop', ['$event'])
  onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;

    if (event.dataTransfer?.files.length) {
      const file = event.dataTransfer.files[0];
      this.processFile(file);
    }
  }

  @HostListener('dragover', ['$event'])
  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = true;
  }

  @HostListener('dragleave', ['$event'])
  onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;
  }

  processFile(file: File) {
    const allowedTypes = ['video/mp4', 'video/quicktime'];
    if (file.size <= 1024 * 1024 * 1024 && allowedTypes.includes(file.type)) {
      this.fileName = file.name;
      this.uploadForm.patchValue({ file });
    } else {
      alert('Invalid file type or size exceeds 1 GB.');
    }
  }

  onSubmit() {
    if (this.uploadForm.valid) {
      console.log('Form data:', this.uploadForm.value);
      this.dialogRef.close(this.uploadForm.value);
    }
  }

  closeDialog() {
    this.uploadForm.reset();
    this.dialogRef.close();
  }
}

